var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTraffic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4892_93283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.68 14.3871H7.01333V16.3871H9.68V14.3871Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0133 10.3871H7.01333V12.3871H15.0133V10.3871Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6.38711H7.01333V8.38711H21V6.38711Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.96 24.4804C16 24.4804 15.2133 23.6938 15.2133 22.7338V14.9738H13.2133V22.7338C13.2133 24.8004 14.8933 26.4804 16.96 26.4804H26.8C27.1467 26.4804 27.48 26.5471 27.8 26.6538L23.7867 30.5604L25.1867 32.0004L29.44 27.8671C29.8 28.3871 30.0133 29.0004 30.0133 29.6804V31.8004H32.0133V29.6804C32.0133 26.8138 29.68 24.4804 26.8133 24.4804H16.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7867 27.5871H18.7867V31.7871H20.7867V27.5871Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0133 11.9071L24.68 11.8271L19.56 13.2938L18.5733 13.5604L19.5067 17.2538C19.4933 17.6138 19.48 17.9871 19.48 18.4404C19.48 21.3204 21.8133 23.6538 24.6933 23.6538C27.5733 23.6538 29.9067 21.3204 29.9067 18.4404V18.2404C29.9067 17.8938 29.8933 17.5871 29.88 17.2671L30.8 13.5738L25.0133 11.9204V11.9071ZM27.9067 18.4271C27.9067 20.2004 26.4667 21.6404 24.6933 21.6404C22.92 21.6404 21.48 20.2004 21.48 18.3204C21.48 18.2271 21.48 18.1338 21.48 18.0404H27.8933C27.8933 18.0404 27.8933 18.1604 27.8933 18.2271V18.4271H27.9067ZM28.1333 16.0404H25.7067V14.9871H23.7067V16.0404H21.28L21.0133 14.9604L24.7067 13.8938L28.4133 14.9471L28.1467 16.0271L28.1333 16.0404Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50667 23.8138H7.46667L4.98667 27.1471V3.77378H23.0133V9.90711H25.0133V3.78711C25.0133 2.68044 24.12 1.78711 23.0133 1.78711H5C3.89333 1.78711 3 2.68044 3 3.78711V29.8138H5.50667L8.01333 26.4538L10.1867 29.3604L11.7867 28.1604L8.85333 24.2271L8.52 23.8004L8.50667 23.8138Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4892_93283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTraffic);
export default __webpack_public_path__ + "static/media/ic-traffic.043893c79e70722d78e6c3266e1fc6c2.svg";
export { ForwardRef as ReactComponent };